import { CanDeactivateFn } from '@angular/router';

import { BaasEditConsumer } from './baas-edit.contracts';

export function baasEditCanDeactivateGuard(): CanDeactivateFn<BaasEditConsumer> {
    return async (component: BaasEditConsumer) => {
        if (component.requestSave) {
            const result = await component.requestSave({ reason: 'autosave' });
            return result.success;
        }
        return true;
    };
}
